export default "__VITE_ASSET__C_BjvX9Q__"